import type {SelectItem} from '@mantine/core';
import {useState} from 'react';
import {FILTER_EMPLOYEE_COUNT_OPTIONS} from '../../../core/entities/company/constants';
import type {ResultGetWorkAttractiveConditions} from '../../../core/repositories/companyRepository';
import type {IndustryCategoriesReturnValueType} from './../../../core/repositories/reportsRepository';
import {getIndustriesFromURL} from './getIndustriesFromURL';

export type FilterEmployeeCountOptions = {
  min: number;
  max: number;
  label: string;
};

export const useHandleCompanyForSearch = (
  industryCategories?: IndustryCategoriesReturnValueType,
  attractiveConditionsData?: ResultGetWorkAttractiveConditions,
  initialAttractiveConditions: string[] = [],
) => {
  const [filterCategories, setFilterCategories] = useState<number[]>([]);
  const [searchWord, setSearchWord] = useState<string>('');
  const [filterMinEmployeeCount, setFilterMinEmployeeCount] =
    useState<number>(0);
  const [filterMaxEmployeeCount, setFilterMaxEmployeeCount] =
    useState<number>(0);
  const [filterAttractiveConditions, setFilterAttractiveConditions] = useState<
    string[]
  >(initialAttractiveConditions);

  getIndustriesFromURL(industryCategories, setFilterCategories);

  const attractiveConditions = attractiveConditionsData?.ok
    ? attractiveConditionsData.value.workAttractiveConditions
    : [];

  const handleSearchInputChange = (searchWord: string) => {
    setSearchWord(searchWord);
  };

  const handleFilterEmployeeCountChange = (optionIndex: number) => {
    if (optionIndex < 0) {
      setFilterMinEmployeeCount(0);
      setFilterMaxEmployeeCount(0);
    } else {
      const option = FILTER_EMPLOYEE_COUNT_OPTIONS[optionIndex];
      if (option) {
        setFilterMinEmployeeCount(option.min);
        setFilterMaxEmployeeCount(option.max);
      }
    }
  };

  const attractiveConditionsList: SelectItem[] = attractiveConditions
    .sort((a, b) => {
      if (!a || !b) return 0;

      if (a.categoryDispOrder !== b.categoryDispOrder) {
        return a.categoryDispOrder - b.categoryDispOrder;
      }

      return a.dispOrder - b.dispOrder;
    })
    .map((item) => ({
      value: item.id.toString(),
      label: item.name ?? '',
    }));

  return {
    industryCategories,
    filterCategories,
    setFilterCategories,
    searchWord,
    handleSearchInputChange,
    filterMinEmployeeCount,
    filterMaxEmployeeCount,
    handleFilterEmployeeCountChange,
    attractiveConditionsList,
    filterAttractiveConditions,
    setFilterAttractiveConditions,
  };
};
